import { TFunction } from 'i18next';
import { IconFormNames } from 'shared/assets/icons';
import { LifeArea } from 'shared/types/life-area';
import { lifeAreaOtherID } from 'shared/types/orderable-section';
import { RoleOption } from 'shared/types/roles';

export enum LifeAreaTypes {
  Other = 'other',
  More = 'more',
}

const typeLabelMap = {
  [LifeAreaTypes.Other]: 'general.sections.life-areas.other.title',
  [LifeAreaTypes.More]: 'general.sections.life-areas.more.title',
};

const typeIconMap = {
  [LifeAreaTypes.Other]: IconFormNames.PlaceholderIcon,
  [LifeAreaTypes.More]: IconFormNames.DotsMenu,
};

export const createOtherLifeArea = (
  t: TFunction,
  type = LifeAreaTypes.Other,
): LifeArea => {
  const now = new Date();
  return {
    archivedAt: null,
    frozenAt: null,
    iconName: typeIconMap[type],
    lifescanValue: null,
    roles: { [RoleOption.All]: [], [RoleOption.Owner]: '' },
    templateId: null,
    sections: null,
    visionPreview: null,
    id: lifeAreaOtherID,
    goalSorting: null,
    createdAt: now,
    updatedAt: now,
    taskSorting: null,
    name: t(typeLabelMap[type]),
  };
};
